<template>
    <div>
        <form method="POST" class="text-center m-r-md" action="" @submit.prevent="login">
            <div class="form-group">
                <label for="email" class="form-label">E-mail</label>
                <input id="email" type="email" class="form-input" name="email" value="" required autofocus
                       v-model="email" placeholder="exemplo@exemplo.com.br">
            </div>

            <div class="form-group">
                <label for="password" class="form-label">Senha</label>
                <input id="password" type="password" class="form-input" name="password" required v-model="password"
                       placeholder="******">
            </div>

            <div class="form-group">
                <div class="block m-b-sm text-right m-r-lg">
                    <span style="font-size:14px;float:left;margin-top:-2px;" class="m-l-lg">
                        <input type="checkbox"> Lembre-me
                    </span>

                    <a href="" data-toggle="modal" data-target="#myModal" style="font-size:14px;">Esqueci minha
                        Senha</a>
                </div>

                <button type="submit" class="form-button">
                    Login <i class="fa fa-user-circle"></i>
                </button>
            </div>
        </form>

        <div id="myModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">Formulário de Recuperação de Senha</h4>
                    </div>

                    <div class="modal-body">
                        <form action="">
                            <div class="form-group">
                                <label for="">E-mail</label>
                                <input type="email" name="email" class="form-control email" v-model="forgot.email">
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-success" @click="forgotPassword">Solicitar Recuperação
                        </button>
                    </div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                password: '',
                forgot: {
                    email: ''
                }
            }
        },
        methods: {
            login() {
                const self = this;
                const api = this.$store.state.api + 'login';

                axios.post(api, {
                    'email': this.email,
                    'password': this.password
                })
                    .then((response) => {
                        self.$store.commit('auth', response.data.access_token);
                            localStorage.setItem('role_id', response.data.role)
                        if (response.data.role === 3) {
                            self.$router.push({path: '/product-ipro'});
                        } else if (response.data.role == 5) {
                            self.$router.push({path: '/notification'});
                        } else {
                            self.$router.push({path: '/'});
                        }
                    })
                    .catch((error) => {
                        self.$message('Erro', 'Credenciais incorretas', 'error')
                    });
            },
            forgotPassword() {
                const self = this;
                const api = this.$store.state.api + 'user/recovery';

                axios.post(api, {
                    'email': self.forgot.email
                })
                    .then((response) => {
                        self.$message('Sucesso', 'Solicitação realizada com sucesso', 'success');
                    })
                    .catch((error) => {
                        self.$message('Erro', error.response.data, 'error');
                    });
            }
        }
    }
</script>

<style>
    body {
        font-family: 'Roboto', sans-serif;
    }

    form .form-input {
        width: 90% !important;
        font-size: 15px !important;
        padding: 10px !important;
        border: 1px solid #c0c0c0;
    }

    form .form-label {
        width: 90% !important;
        display: block;
        text-align: left;
        font-size: 16px !important;
        margin-left: auto;
        margin-right: auto;
    }

    form .form-button {
        width: 90%;
        padding: 10px;
        font-size: 18px;
        border-radius: 30px;
        margin-left: auto;
        margin-right: auto;
        border: 1px solid #f0f0f0;
        background: #ffdf48 !important;
    }

    @media (max-width: 768px) {
        .ibox {
            margin: 0px 0px 0px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue